import { useTranslation } from 'react-i18next'
import { useRef } from 'react'
import { LinearProgress } from '@material-ui/core'
import { KnowledgeBaseContentFilesFormFields } from 'components/forms/KnowledgeBaseContentFilesForm/types'
import { KnowledgeBaseContentFilesForm } from 'components/forms/KnowledgeBaseContentFilesForm/KnowledgeBaseContentFilesForm'
import { Modal, ModalProps } from 'components/layout/Modal/Modal'
import * as Styled from './AddFilesModal.styles'

interface AddFilesModalProps extends Omit<ModalProps, 'children' | 'onClose'> {
  open: boolean
  initialValues?: KnowledgeBaseContentFilesFormFields
  onClose: () => void
  onSave: (values: KnowledgeBaseContentFilesFormFields) => void
  isLoading?: boolean
  isError?: boolean
  uploadProgress?: number,
}

const AddFilesModal = ({
  open,
  initialValues,
  onClose: handleClose,
  onSave: handleSave,
  isLoading,
  isError,
  uploadProgress,
}: AddFilesModalProps): JSX.Element => {
  const {
    t,
  } = useTranslation()

  const handleCloseModal = () => {
    handleClose()
  }

  const submitRef = useRef<() => void>(() => {})

  return (
    <Styled.Modal open={open} onClose={handleCloseModal}>
      <Modal.Title variant='h3'>{t('knowledgeBase.files')}</Modal.Title>
      <Styled.ModalContent>
        <KnowledgeBaseContentFilesForm
          initialValues={initialValues}
          onSave={handleSave}
          submitRef={submitRef}
          isLoading={isLoading}
        />
      </Styled.ModalContent>
      {!!uploadProgress && (
        <Styled.ModalLoaderContent>
          <LinearProgress variant='determinate' value={uploadProgress} />
        </Styled.ModalLoaderContent>
      )}
      <Modal.Actions
        isLoading={isLoading}
        isSaveDisabled={isError}
        onCancel={handleCloseModal}
        onSave={() => submitRef.current()}
        confirmLabel={t('common.save')}
      />
    </Styled.Modal>
  )
}

export { AddFilesModal }
